
import * as Yup from "yup";

export const loginValidationSchema = Yup.object().shape({
    email: Yup
        .string()
        .trim()
        .email("Invalid email address")
        .required("Email is required")
        .matches(
            /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
            "Invalid email address"
        ),
    password: Yup
        .string()
        .required("Password is required")
});

export const step1ValidationSchema = Yup.object().shape({
    email: Yup.string().email().required("This field is required"),
});

export const step2ValidationSchema = Yup.object().shape({
    otp: Yup.number().required("This field is required"),
});

export const step3ValidationSchema = Yup.object().shape({
    password: Yup.string()
        .min(6, "Password must be at least 6 characters long")
        .required("This field is required"),
});